import Event from '../event';
import indexEvents from 'actions/event/index';
import indexConflicts from 'actions/conflict/index';

/**
 * Create the action
 */

const { thunk, request, success, error } = Event.store((data, fetch, dispatch) => {

    if (data.image) {
        // Prepare request
        let formData = new FormData();

        const fields = Object.keys(data);
 
        fields.map((field) => {
            formData.append(field, data[field]);
        });

        return fetch.post('events', formData).then((response) => {
            dispatch(indexEvents({}));
            dispatch(indexConflicts());
            return response;
        });

    } else {
        return fetch.post('events', data).then((response) => {
            dispatch(indexEvents({}));
            dispatch(indexConflicts());
            return response;
        });
    }

    
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };